var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiPoweredIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 36,
    transform: "translate(3073 11314)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3073 -11314)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.328 -46.029)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3062.672 11361.029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.592-.75A8.342,8.342,0,1,1-.75,7.592,8.351,8.351,0,0,1,7.592-.75Zm0,15.184A6.842,6.842,0,1,0,.75,7.592,6.85,6.85,0,0,0,7.592,14.434Z",
    transform: "translate(7.527)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.319,1182.65H69.375a.75.75,0,0,1,0-1.5h6.776a14.037,14.037,0,0,0-14.368-13.828,14.037,14.037,0,0,0-14.368,13.828h6.776a.75.75,0,0,1,0,1.5H47.248a1.335,1.335,0,0,1-1.334-1.334,15.209,15.209,0,0,1,4.657-11.042,16.347,16.347,0,0,1,22.424,0,15.209,15.209,0,0,1,4.657,11.042A1.335,1.335,0,0,1,76.319,1182.65Z",
    transform: "translate(-46.664 -1151.388)",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-59.134 -1149.858)",
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3062.672 11361.029)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.49 21.214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2-.75H17.259A2.753,2.753,0,0,1,20.009,2V8.721a5.151,5.151,0,0,1-5.145,5.145H4.4A5.151,5.151,0,0,1-.75,8.721V2A2.753,2.753,0,0,1,2-.75ZM14.864,12.366a3.649,3.649,0,0,0,3.645-3.645V2A1.251,1.251,0,0,0,17.259.75H2A1.251,1.251,0,0,0,.75,2V8.721A3.649,3.649,0,0,0,4.4,12.366Z",
    fill: "#6b19ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.259.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H19.259a.75.75,0,0,1,.75.75A.75.75,0,0,1,19.259.75Z",
    transform: "translate(0 9.262)",
    fill: "#6b19ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.045-.75A1.795,1.795,0,1,1-.75,1.045,1.8,1.8,0,0,1,1.045-.75Zm0,2.089A.295.295,0,1,0,.75,1.045.295.295,0,0,0,1.045,1.339Z",
    transform: "translate(14.075 25.184)",
    fill: "#6b19ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPoweredIcon);
export default __webpack_public_path__ + "static/media/ai-powered-icon.2268364cea9d5b11c74bb4b6bdf989cc.svg";
export { ForwardRef as ReactComponent };